import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'
import Tooltip from '@tippy.js/react'
import history from 'configureHistory'
import EE from 'emitter.js'

import {
	Icon,
	ButtonGroup,
	Button,
	Confirm,
	Label,
	FormLabel,
} from 'components'

class ContextMenu extends Component {
	onCreate = tippy => {
		this.tippy = tippy
	}

	closeTippy = () => {
		this.tippy.hide()
	}

	render() {
		const {
			id,
			draft,
			outdated,
			allowSubEntry,
			onDuplicate,
			onRemove,
			onChangeArticleState,
			onChangeOutdatedState,
			onAddSubEntry,
			t,
		} = this.props

		return (
			<Tooltip
				onCreate={this.onCreate}
				trigger="click"
				theme="min-width-small"
				animation="shift-away"
				animateFill={false}
				interactive
				placement="right-start"
				content={
					<ButtonGroup>
						<Button
							text={t('status.draft')}
							icon={<Icon name="draft" />}
							layout="tertiary"
							fullWidth
							size="small"
							onClick={e => {
								e.stopPropagation()

								this.closeTippy()
								onChangeArticleState(id, !draft)
							}}
							metaContent={
								<>
									<input
										className="o-switch__input"
										type="checkbox"
										checked={!!draft}
										readOnly
									/>
									<FormLabel className="o-switch__label" />
								</>
							}
						/>
						<Confirm
							text={
								outdated
									? t('tag_as_current_text')
									: t('tag_as_outdated_text')
							}
							buttonText={
								outdated
									? t('tag_as_current_button')
									: t('tag_as_outdated_button')
							}
							buttonLayout="primary"
							onOpen={() => {
								this.closeTippy()
							}}
						>
							{confirm => (
								<Button
									text={t('status.outdated')}
									icon={<Icon name="outdated" />}
									layout="tertiary"
									fullWidth
									size="small"
									onClick={confirm(() => {
										onChangeOutdatedState(id, !outdated)
									})}
									metaContent={
										<>
											<input
												className="o-switch__input"
												type="checkbox"
												checked={!!outdated}
												readOnly
											/>
											<FormLabel className="o-switch__label" />
										</>
									}
								/>
							)}
						</Confirm>
						<hr className="o-button-group__divider" />
						<Button
							onClick={e => {
								e.stopPropagation()
								this.closeTippy()

								EE.emit('showFeedbackModal', {
									articleId: id,
								})
							}}
							text={t('give_feedback')}
							icon={<Icon name="feedback" />}
							size="small"
							layout="tertiary"
							fullWidth
						/>
						<Button
							onClick={e => {
								e.stopPropagation()
								// console.log(`${id}#editing-history`)

								this.closeTippy()
								history.push(`${id}#editing-history`)
							}}
							text={t('editing_history')}
							icon={<Icon name="editing-history" />}
							size="small"
							// label={<Label text="Pro" theme="important" />}
							layout="tertiary"
							fullWidth
						/>
						<Button
							onClick={e => {
								e.stopPropagation()
								this.closeTippy()

								EE.emit('showResponsiblePersonsModal', {
									articleId: id,
								})
							}}
							text={t('responsible_persons')}
							icon={<Icon name="responsible" />}
							size="small"
							layout="tertiary"
							fullWidth
						/>
						<hr className="o-button-group__divider" />
						{allowSubEntry && (
							<Button
								text={t('sidebar.new_subentry')}
								icon={<Icon name="new-entry" />}
								layout="tertiary"
								fullWidth
								size="small"
								onClick={e => {
									e.stopPropagation()

									this.closeTippy()
									onAddSubEntry()
								}}
							/>
						)}
						<Button
							text={t('duplicate')}
							icon={<Icon name="duplicate" />}
							layout="tertiary"
							fullWidth
							size="small"
							onClick={e => {
								e.stopPropagation()

								this.closeTippy()
								onDuplicate()
							}}
						/>
						<Confirm
							text={t('delete_question')}
							buttonText={t('delete_long')}
							onOpen={() => {
								this.closeTippy()
							}}
						>
							{confirm => (
								<Button
									text={t('delete')}
									icon={<Icon name="delete" />}
									layout="tertiary"
									fullWidth
									size="small"
									onClick={confirm(() => {
										onRemove()
									})}
								/>
							)}
						</Confirm>
					</ButtonGroup>
				}
			>
				<Button
					className="tippy-link o-sortable-tree__action-button"
					icon={<Icon name="dot-3" />}
				/>
			</Tooltip>
		)
	}
}

ContextMenu.propTypes = {}

export default translate()(ContextMenu)
